export enum TokenProvider {
    SamsungPay = 'samsungpay',
    GooglePay = 'googlepay',
    ApplePay = 'applepay',
    YandexPay = 'yandexpay',
}
